import React from 'react'
import { css } from '@emotion/core'
import type { RestaurantOverviewSortKey, RestaurantSortOrder } from '@/models/restaurant-manager'

type Props = {
  label: string
  columnKey: RestaurantOverviewSortKey
  sortKey?: RestaurantOverviewSortKey
  sortOrder?: RestaurantSortOrder
  onChangeSort: (sortKey: RestaurantOverviewSortKey, sortOrder: RestaurantSortOrder) => void
}

export const RestaurantSortableColumnHeader: React.FC<Props> = ({ label, columnKey, sortKey, sortOrder, onChangeSort }) => {
  const isActive = sortKey === columnKey
  const iconSrc =
    isActive && sortOrder === 'desc' ? require('@/static/images/icon_arrow_down_2.svg') : require('@/static/images/icon_arrow_up_2.svg')

  return (
    <button type="button" css={buttonStyle} onClick={() => onChangeSort(columnKey, isActive && sortOrder === 'asc' ? 'desc' : 'asc')}>
      <span>{label}</span>
      <img css={iconStyle(isActive)} src={iconSrc} alt="" aria-hidden />
    </button>
  )
}

const buttonStyle = css({
  alignItems: 'center',
  appearance: 'none',
  background: 'transparent',
  border: 'none',
  color: 'inherit',
  cursor: 'pointer',
  display: 'inline-flex',
  font: 'inherit',
  fontWeight: 'inherit',
  gap: 4,
  margin: 0,
  padding: 0,
  position: 'relative',
  width: '100%',
  ':hover > img': {
    opacity: 0.5,
  },
})

const iconStyle = (isActive: boolean) =>
  css({
    filter: 'brightness(0) saturate(100%) invert(47%) sepia(0%) saturate(3541%) hue-rotate(185deg) brightness(86%) contrast(101%)',
    opacity: isActive ? 1 : 0,
    width: '1rem',
  })
